import { Stack } from '@mui/material';

import { CoteamLogo } from 'src/assets/CoteamLogo';
import { ToggleRoleButton } from 'src/layouts/dashboard/navbar/ToggleRoleButton';
import { HelpButton } from 'src/layouts/dashboard/navbar/HelpButton';
import { NavbarMemberContents } from 'src/layouts/dashboard/navbar/member/NavbarMemberContents';
import { OpinionButton } from 'src/layouts/dashboard/navbar/OpinionButton';
import { AccountPopover } from 'src/layouts/dashboard/navbar/AccountPopover';
import { useOrganization } from 'src/contexts/OrganizationContext';

type Props = {
  setRole: React.Dispatch<React.SetStateAction<'admin' | 'member'>>;
};
export const NavbarMemberMenu = ({ setRole }: Props) => {
  const { currentUser, isLoading } = useOrganization();

  // ローディング中は基本構造のみ表示
  if (isLoading) {
    return (
      <Stack sx={{ height: '100%', justifyContent: 'space-between' }}>
        <Stack sx={{ py: '16px' }}>
          <CoteamLogo />
        </Stack>
      </Stack>
    );
  }

  return (
    <Stack
      sx={{
        height: '100%',
        justifyContent: 'space-between',
      }}
    >
      <Stack
        sx={{
          py: '16px',
          height: '100%',
          justifyContent: 'space-between',
        }}
      >
        <Stack gap="16px">
          <CoteamLogo />
          <NavbarMemberContents />
        </Stack>
        {currentUser && (
          <Stack gap="8px" px="16px">
            <OpinionButton role="member" />
            <HelpButton role="member" />
            <ToggleRoleButton role="member" setRole={setRole} />
          </Stack>
        )}
      </Stack>
      {currentUser && (
        <Stack px="16px">
          <AccountPopover role="member" />
        </Stack>
      )}
    </Stack>
  );
};
